import { getMaterialCategory } from "../AddLoad/AdddLoad.Config";

const MaterialCategoryField = [
  {
    name: "Material_Category",
    fields: [
      {
        id: Math.random() * 10,
        name: "Material_Category_Name",
        label: "Material Category Name",
        type: "text",
        autoFocus: true,
      },
    ],
  },
];

const MaterialCategoryForMerge = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Category_Master",
    fields: [
      {
        id: Math.random() * 10,
        name: "Material_Category_Name",
        label: "Category Name",
        type: "InputDropForQuery",
        dropdowndata: getMaterialCategory,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "replace_with",
        label: "Relace With",
        masterName: "Material_Category",
        type: "InputDropForQuery",
        dropdowndata: getMaterialCategory,
      },
    ],
  },
];

export { MaterialCategoryField, MaterialCategoryForMerge };
